import React from 'react';
import styled from 'styled-components';

import Btn from '../../buttons/Btn';
import { colors, radius, spacing } from '../tokens';
import { Accompagnement } from '../types';
import {
  Actions, BackLink, ErrorBanner, Panel, Reassurance, StepText, StepTitle,
} from './styles';

const ChangeOfMindBlock = styled.div`
  padding: ${spacing.lg};
  border: 1px dashed ${colors.brandMedium};
  border-radius: ${radius.medium};
  background-color: ${colors.brandSoft};
  margin-top: ${spacing.xl};
`;

const ChangeOfMindTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.text};
  margin: 0 0 ${spacing.xs};
`;

type FreePathStepProps = {
  demarcheName: string;
  officialUrl: string;
  guideUrl: string;
  hubHref: string;
  accompagnement: Accompagnement | null;
  situationAllowsAccompagnement: boolean;
  isSwitchingToPaid?: boolean;
  switchToPaidErrorMessage?: string | null;
  onBack: () => void;
  onSwitchToPaid: () => void;
};

const FreePathStep: React.FC<FreePathStepProps> = ({
  demarcheName,
  officialUrl,
  guideUrl,
  hubHref,
  accompagnement,
  situationAllowsAccompagnement,
  isSwitchingToPaid = false,
  switchToPaidErrorMessage = null,
  onBack,
  onSwitchToPaid,
}) => (
  <Panel>
    <StepTitle>C’est à vous de jouer</StepTitle>
    <StepText>
      {`Voici comment poursuivre la démarche « ${demarcheName} » directement auprès de l’administration.`}
    </StepText>
    <Actions>
      <Btn type="button" name="demarche-funnel-free-back" text="Retour" outlined block onClick={onBack} />
      <Btn
        type="button"
        name="demarche-funnel-free-official"
        text="Accéder au service officiel"
        block
        onClick={() => window.open(officialUrl, '_blank', 'noopener')}
      />
    </Actions>
    <Actions>
      <BackLink href={guideUrl} download>
        {`Télécharger le guide « ${demarcheName} »`}
      </BackLink>
    </Actions>
    <Reassurance>VroomVroom est un service privé indépendant de France Titres — ANTS.</Reassurance>
    <Actions>
      <a href={hubHref}>Voir toutes les démarches</a>
    </Actions>

    {situationAllowsAccompagnement && accompagnement && (
      <ChangeOfMindBlock>
        <ChangeOfMindTitle>Vous avez changé d’avis ?</ChangeOfMindTitle>
        <StepText>
          {'Nous pouvons vérifier votre dossier et le transmettre à votre place, pour '
            + `${accompagnement.price.toFixed(2).replace('.', ',')} € TTC. Vos coordonnées sont déjà `
            + 'enregistrées, il ne reste que quelques étapes.'}
        </StepText>
        <Actions>
          <Btn
            type="button"
            name="demarche-funnel-free-switch-to-paid"
            text="Être accompagné par un pro"
            block
            isLoading={isSwitchingToPaid}
            disabled={isSwitchingToPaid}
            onClick={onSwitchToPaid}
          />
        </Actions>
        {switchToPaidErrorMessage && <ErrorBanner>{switchToPaidErrorMessage}</ErrorBanner>}
      </ChangeOfMindBlock>
    )}
  </Panel>
);

export { FreePathStep };
